import React from 'react';
import { Ellipsis, Page, PaginationContainer } from './styled';
import { getPaginationPages } from './helpers';
import { Arrow, ArrowDirection } from '../../../icons/Arrow';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isPashaLanding?: boolean;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  isPashaLanding
}) => {
  const handleClick = (page: number | string) => {
    if (typeof page === 'number' && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <PaginationContainer $isPashaLanding={isPashaLanding}>
      <Arrow
        disabled={currentPage === 1}
        direction={ArrowDirection.left}
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
      />
      {getPaginationPages(currentPage, totalPages).map((page, index) =>
        page === '...' ? (
          <Ellipsis key={index}>…</Ellipsis>
        ) : (
          <Page
            key={index}
            isActive={page === currentPage}
            onClick={() => handleClick(page)}
          >
            {page}
          </Page>
        )
      )}
      <Arrow
        disabled={currentPage === totalPages}
        direction={ArrowDirection.right}
        onClick={() =>
          currentPage < totalPages && onPageChange(currentPage + 1)
        }
      />
    </PaginationContainer>
  );
};

export default Pagination;
